import React from 'react';
import ReactDOM from 'react-dom/client';
import { api } from 'utility';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import ErrorBoundary from './ErrorBoundary';

// import TagManager from 'react-gtm-module';

// const tagManagerArgs = {
//   gtmId: process.env?.REACT_APP_GOOGLE_TAG_MANAGER,
// };
// TagManager.initialize(tagManagerArgs);
let baseUrl;
if (process.env?.REACT_APP_API_JAVA) {
  baseUrl = `${process.env.REACT_APP_API_JAVA}${process.env.REACT_APP_BASE_URL}`;
} else {
  baseUrl = `${process.env.REACT_APP_BASE_URL}`;
}
api.axios.defaults.baseURL = baseUrl;
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <BrowserRouter>
      <App />
    </BrowserRouter>

  </ErrorBoundary>
);

serviceWorker.unregister();
